<template>
  <div class="d-flex justify-center payment">
    <div class="block-width">
      <h1 class="mt-0 mb-05 text-center">{{ $t('choose_plan') }}</h1>
      <div class="d-flex justify-center">
        <p class="text-center c-metal-500 mb-2 w-58 mt-0">
          {{ $t('choose_plan_text') }}
        </p>
      </div>
      <div class="d-flex justify-center align-center fw-400 mb-2">
        <span class="fw-400">{{ $t('monthly') }}</span>
        <label class="switch mr-05 ml-05">
          <input type="checkbox" checked v-model="isAnnual">
          <span class="slider round"></span>
        </label>
        <span class="fw-400">{{ $t('yearly') }}</span>
      </div>
      <div class="d-flex justify-between payment__row">
        <div class="payment-card">
          <div class="payment-card__header payment-card__header__violet">
            <h5 class="mb-05 mt-0 fw-600">LITE</h5>
            <div class="text-body">{{ $t('lite_text') }}</div>
          </div>
          <div class="payment-card__content">
            <h4 class="mt-0 text-center mb-0">{{ $t('free') }}</h4>
            <p class="text-body c-metal-500 text-center mb-1">{{ period }} {{ $t('for_user') }}</p>
            <div class="d-flex align-center mb-1">
              <img src="@/assets/images/icons/plus-circle.svg" class="mr-05" alt="icon"/>
              <span class="text-body">{{ $t('lite_1') }}</span>
            </div>
            <div class="d-flex align-center mb-1">
              <img src="@/assets/images/icons/plus-circle.svg" class="mr-05" alt="icon"/>
              <span class="text-body">{{ $t('lite_2') }}</span>
            </div>
            <div class="d-flex align-center mb-1">
              <img src="@/assets/images/icons/plus-circle.svg" class="mr-05" alt="icon"/>
              <span class="text-body">{{ $t('lite_3') }}</span>
            </div>
            <div class="d-flex align-center mb-1">
              <img src="@/assets/images/icons/plus-circle.svg" class="mr-05" alt="icon"/>
              <span class="text-body">{{ $t('lite_4') }}</span>
            </div>
            <div class="d-flex align-center mb-1">
              <img src="@/assets/images/icons/plus-circle.svg" class="mr-05" alt="icon"/>
              <span class="text-body">{{ $t('lite_5') }}</span>
            </div>
            <div class="d-flex align-center mb-1">
              <img src="@/assets/images/icons/plus-circle.svg" class="mr-05" alt="icon"/>
              <span class="text-body">{{ $t('lite_6') }}</span>
            </div>
            <div class="d-flex align-center mb-1">
              <img src="@/assets/images/icons/plus-circle.svg" class="mr-05" alt="icon"/>
              <span class="text-body">{{ $t('lite_7') }}</span>
            </div>
            <div class="d-flex align-center mb-3">
              <img src="@/assets/images/icons/plus-circle.svg" class="mr-05" alt="icon"/>
              <span class="text-body">{{ $t('lite_8') }}</span>
            </div>
          </div>
          <div class="d-flex justify-center payment-card__footer">
            <TheButtonPrimary :is-plain="true" :content="$t('choose_plan_1')" @click="choosePlan('lite')"/>
          </div>
        </div>

        <div class="payment-card">
          <div class="payment-card__header payment-card__header__blue">
            <h5 class="mb-05 mt-0 fw-600">PRO</h5>
            <div class="text-body">{{ $t('pro_text') }}</div>
          </div>
          <div class="payment-card__content">
            <h4 class="mt-0 text-center mb-0">{{ price }} ₸</h4>
            <p class="text-body c-metal-500 text-center mb-1">{{ period }} {{ $t('for_user') }}</p>
            <div class="d-flex align-center mb-1">
              <img src="@/assets/images/icons/plus-circle.svg" class="mr-05" alt="icon"/>
              <span class="text-body">{{ $t('lite_1') }}</span>
            </div>
            <div class="d-flex align-center mb-1">
              <img src="@/assets/images/icons/plus-circle.svg" class="mr-05" alt="icon"/>
              <span class="text-body">{{ $t('lite_2') }}</span>
            </div>
            <div class="d-flex align-center mb-1">
              <img src="@/assets/images/icons/plus-circle.svg" class="mr-05" alt="icon"/>
              <span class="text-body">{{ $t('lite_3') }}</span>
            </div>
            <div class="d-flex align-center mb-1">
              <img src="@/assets/images/icons/plus-circle.svg" class="mr-05" alt="icon"/>
              <span class="text-body">{{ $t('lite_4') }}</span>
            </div>
            <div class="d-flex align-center mb-1">
              <img src="@/assets/images/icons/plus-circle.svg" class="mr-05" alt="icon"/>
              <span class="text-body">{{ $t('lite_5') }}</span>
            </div>
            <div class="d-flex align-center mb-1">
              <img src="@/assets/images/icons/plus-circle.svg" class="mr-05" alt="icon"/>
              <span class="text-body">{{ $t('lite_6') }}</span>
            </div>
            <div class="d-flex align-center mb-1">
              <img src="@/assets/images/icons/plus-circle.svg" class="mr-05" alt="icon"/>
              <span class="text-body">{{ $t('lite_7') }}</span>
            </div>
            <div class="d-flex align-center mb-3">
              <img src="@/assets/images/icons/plus-circle.svg" class="mr-05" alt="icon"/>
              <span class="text-body">{{ $t('lite_8') }}</span>
            </div>
          </div>
          <div class="d-flex justify-center payment-card__footer">
            <TheButtonPrimary :is-plain="true" :content="$t('choose_plan_1')" @click="choosePlan('pro')"/>
          </div>
        </div>

        <div class="payment-card">
          <div class="payment-card__header payment-card__header__pink">
            <h5 class="mb-05 mt-0 fw-600">ENTERPRISE</h5>
            <div class="text-body">{{ $t('enterprise_text') }}</div>
          </div>
          <div class="payment-card__content d-flex flex-col justify-between">
            <div>
              <h4 class="mt-0 text-center mb-1">{{$t('enterprise')}}</h4>
              <p class="text-body c-metal-500 mb-1">{{$t('enterprise_1')}}</p>
            </div>
          </div>
          <div class="d-flex justify-center payment-card__footer">
            <TheButtonPrimary :is-plain="true" :content="$t('choose_plan_1')" @click="choosePlan('enterprise')"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import TheButtonPrimary from "@/components/TheButton/TheButtonPrimary.vue";
import {ref, computed} from 'vue'
import {useI18n} from "vue-i18n";
import {useRouter} from "vue-router";

const {t} = useI18n()
const router = useRouter()
const price = computed(()=>isAnnual.value? '49 500': '4 500');
const isAnnual = ref(false)
const period = computed(()=> isAnnual.value?t('per_year'):t('per_month'))
const choosePlan = (plan) => {
  if(plan==='lite'){
    router.push({name: 'contact-us', params: {message: `${t('message_text_2')} - ${isAnnual.value?t('per_year'):t('per_month')}`}})
  }
  else if(plan==='pro'){
    router.push({name: 'contact-us', params: {message: `${t('message_text_3')} - ${isAnnual.value?t('per_year'):t('per_month')}`}})
  }
  else{
    router.push({name: 'contact-us', params: {message: `${t('message_text_4')} - ${isAnnual.value?t('per_year'):t('per_month')}`}})
  }
}
</script>